<template>
  <div class="d-flex gap-4">
    <div v-for="field in fields" :key="field.key" class="form-field" :class="field.classes">
      <span>{{ field.title || '&nbsp;' }}</span>
      <InputSearch v-if="field.type === 'search'"
        :value="filterValues[field.key]"
        :placeholder="field.placeholder"
        @input="onFilterChange(field.key, $event, 500)" />
      <Multiselect v-else-if="field.type === 'select'"
        :value="filterValues[field.key]"
        :options="field.options"
        :track-by="field.trackBy"
        :label="field.label"
        :searchable="field.searchable"
        :show-labels="field.showLabels"
        :allow-empty="field.allowEmpty"
        :max-height="field.maxHeight"
        :multiple="field.multiple"
        :placeholder="field.placeholder"
        @input="onFilterChange(field.key, $event)">
        <template slot="singleLabel" slot-scope="{ option }">
          {{ option[field.label] || option[field.alternateLabel] }}
        </template>
        <template slot="selection" slot-scope="{ values, isOpen }">
          <span class="multiselect__single" v-if="values.length && !isOpen">
            {{ values.length === 1 ? (values[0][field.label] || values[0][field.alternateLabel]) : `${values.length} options selected` }}
          </span>
        </template>
        <template slot="option" slot-scope="{ option }">
          <div :class="['option__desc text-truncate']">
            <span class="option__title">{{ option[field.label] || option[field.alternateLabel] }}</span>
            <br>
            <small v-if="option.locationType === 'sab'" class="d-block option__small">Service Area Business</small>
            <small v-else-if="option.address" class="d-block option__small">{{ option.address }} </small>
            <small v-if="option.storeCode" class="d-block option__small">{{ option.storeCode }} </small>
          </div>
        </template>
      </Multiselect>
      <DatePicker v-else-if="field.type === 'selectMonth'"
        class="w-100"
        date-format="Y-m-d"
        :just-months="true"
        @input="onFilterChange(field.key, $event)" />
      <input v-else
        type="text"
        :value="filterValues[field.key]"
        :placeholder="field.placeholder"
        @input="onFilterChange(field.key, $event)">
    </div>
    <div class="form-field w-auto">
      <span>&nbsp;</span>
      <button class="btn btn-outline-primary px-0 border-0 gap-2 text-muted" @click="clear">
        <i class="fas fa-eraser" aria-hidden="true" />
        Clear filters
      </button>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import DatePicker from 'vue_widgets/components/datepicker'
import InputSearch from 'vue_widgets/components/input_search_ui'

export default {
  components: { InputSearch, Multiselect, DatePicker },
  props: {
    fields: { type: Array, required: true }
  },
  data() {
    return {
      filterValues: {}
    }
  },
  methods: {
    onFilterChange(key, $event, delay = 0, clearFilter = false) {
      if (clearFilter) this.filterValues = {}
      clearTimeout(this.timeout)
      this.$set(this.filterValues, key, $event)
      this.timeout = setTimeout(() => {
        const filter = {}
        Object.keys(this.filterValues).forEach((field) => {
          filter[field] = this.filterValues[field]

          if (typeof this.filterValues[field] === 'object' &&
            !Array.isArray(this.filterValues[field]) &&
            this.filterValues[field]) {
            filter[field] = this.filterValues[field].id
          }

          if (Array.isArray(this.filterValues[field])) {
            filter[field] = this.filterValues[field].map((value) => value.id)
          }
        })

        this.$emit('onFilterChange', filter)
      }, delay)
    },
    clear() {
      this.filterValues = {}
      this.$emit('onFilterChange', {})
    }
  }
}
</script>
